import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isArea' })
export class IsAreaPipe implements PipeTransform {
  transform(area: string, ...expectedAreas: string[]): boolean {
    return expectedAreas.some(expected => expected === area);
  }
}
